import { ReactElement } from 'react';
import { classNames } from '/shared/lib/classNames/classNames';
import s from './MainLayout.module.scss';

interface MainLayoutProps {
  className?: string;
  header?: ReactElement;
  mobileHeader?: ReactElement;
  content?: ReactElement;
}

export const MainLayout = (props: MainLayoutProps) => {
  const { className, header, content, mobileHeader } = props;

  return (
    <div className={classNames(s.MainLayout, {}, [className])}>
      {mobileHeader}
      {header && <div className={s.header}>{header}</div>}
      <div className={s.content} id='map-content'>
        {content}
      </div>
    </div>
  );
};
